var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThinChevronRoundRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.12 156.92a9.779 9.779 0 0 0-13.92-.12c-3.87 3.85-3.92 10.15-.11 14.06l83.71 86.31-83.63 83.89c-3.85 3.87-3.87 10.16-.04 14.05a9.77 9.77 0 0 0 13.92.05l90.56-90.85c3.83-3.85 3.87-10.12.07-14.02l-90.56-93.37z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 256c0-70.69-28.66-134.7-74.98-181.02C390.69 28.66 326.69 0 256 0 185.31 0 121.3 28.66 74.98 74.98 28.66 121.3 0 185.31 0 256c0 70.69 28.65 134.7 74.98 181.02C121.3 483.34 185.31 512 256 512c70.69 0 134.69-28.66 181.02-74.98C483.34 390.7 512 326.69 512 256zM422.92 89.08c42.71 42.72 69.14 101.73 69.14 166.92 0 65.18-26.42 124.2-69.14 166.92-42.72 42.71-101.74 69.14-166.92 69.14-65.19 0-124.21-26.42-166.92-69.14C46.36 380.21 19.94 321.19 19.94 256c0-65.19 26.43-124.2 69.14-166.92C131.79 46.36 190.81 19.94 256 19.94c65.18 0 124.2 26.43 166.92 69.14z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThinChevronRoundRightIcon);
export default __webpack_public_path__ + "static/media/thin-chevron-round-right-icon.190122b68ae549de2c7a90f1eb28e076.svg";
export { ForwardRef as ReactComponent };